export const isIPad = () => {
  return /iPad|Macintosh/.test(navigator.userAgent) && "ontouchend" in document;
};
